<template>
  <div class="footer-page-container">
    <div class="page-content">
      <h1 class="page-title">帮助中心</h1>
      <div class="page-body">
        <section class="help-intro">
          <h2>帮助中心</h2>
          <p>如果您在使用过程中遇到任何问题，欢迎查看我们的帮助文档。如果您的问题没有得到解答，可以随时联系我们的客服人员。</p>
        </section>
        
        <section class="help-faq" style="margin-top: 30px;">
          <h2>常见问题</h2>
          
          <h3>1. 账户相关问题</h3>
          <div class="faq-item">
            <h4>如何注册账户？</h4>
            <p>您可以通过点击网站右上角的"注册"按钮，填写相关信息完成注册。</p>
          </div>
          <div class="faq-item">
            <h4>忘记密码怎么办？</h4>
            <p>您可以在登录页面点击"忘记密码"，按照提示重置密码。</p>
          </div>
          <div class="faq-item">
            <h4>如何修改个人信息？</h4>
            <p>登录账户后，进入"个人中心"，点击"个人信息"进行修改。</p>
          </div>
          
          <h3 style="margin-top: 20px;">2. 课程学习问题</h3>
          <div class="faq-item">
            <h4>如何购买课程？</h4>
            <p>您可以浏览课程列表，选择感兴趣的课程，点击"立即购买"完成支付。</p>
          </div>
          <div class="faq-item">
            <h4>购买课程后如何学习？</h4>
            <p>购买成功后，您可以在"我的课程"中找到已购买的课程，点击"开始学习"即可。</p>
          </div>
          <div class="faq-item">
            <h4>课程有效期是多久？</h4>
            <p>不同课程的有效期可能不同，具体以课程详情页为准。</p>
          </div>
          
          <h3 style="margin-top: 20px;">3. 支付退款问题</h3>
          <div class="faq-item">
            <h4>支持哪些支付方式？</h4>
            <p>我们支持支付宝、微信支付、银行卡等多种支付方式。</p>
          </div>
          <div class="faq-item">
            <h4>如何申请退款？</h4>
            <p>您可以在"我的订单"中找到需要退款的订单，点击"申请退款"，按照提示操作。</p>
          </div>
          <div class="faq-item">
            <h4>退款多久到账？</h4>
            <p>退款一般会在1-3个工作日内到账，具体以支付方式的处理时间为准。</p>
          </div>
          
          <h3 style="margin-top: 20px;">4. 考试相关问题</h3>
          <div class="faq-item">
            <h4>如何参加考试？</h4>
            <p>您可以在"我的考试"中找到需要参加的考试，点击"开始考试"即可。</p>
          </div>
          <div class="faq-item">
            <h4>考试成绩如何查询？</h4>
            <p>考试结束后，系统会自动评分，您可以在"我的考试"中查看成绩。</p>
          </div>
          <div class="faq-item">
            <h4>如何下载证书？</h4>
            <p>考试通过后，您可以在"我的证书"中下载电子版证书。</p>
          </div>
        </section>
        
        <section class="help-contact" style="margin-top: 30px;">
          <h2>联系方式</h2>
          <div class="contact-info">
            <p><strong>客服热线：</strong>400-100-0000</p>
            <p><strong>服务时间：</strong>周一至周日 9:00-21:00</p>
            <p><strong>电子邮箱：</strong>service@yingcaijihua.com</p>
            <p><strong>在线客服：</strong><a href="javascript:void(0);" style="color: #3E2CCD; text-decoration: underline;">点击咨询</a></p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpCenter',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="scss">
.footer-page-container {
  max-width: 1200px;
  margin: 100px auto 0;
  padding: 40px 20px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.page-body {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  p {
    margin-bottom: 15px;
  }
}
</style>